/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LockProjectResponse } from '../../models/lock-project-response';

export interface ProjectsControllerLockProject$Params {

/**
 * Project id.
 */
  id: string;
}

export function projectsControllerLockProject(http: HttpClient, rootUrl: string, params: ProjectsControllerLockProject$Params, context?: HttpContext): Observable<StrictHttpResponse<LockProjectResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerLockProject.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LockProjectResponse>;
    })
  );
}

projectsControllerLockProject.PATH = '/planning-projects/v1-develop/projects/{id}/lock';
